import { useMemo } from 'react';
import { FetchUserGuard } from '../fetch-user-guard';
import { useAuthenticatedWebRouter } from './useAuthenticatedWebRouter';
import { useCommonWebRouter } from './useCommonWebRouter';
import { usePublicWebRouter } from './usePublicWebRouter';

export const useWebRouter = () => {
  const publicWebRouter = usePublicWebRouter();
  const commonWebRouter = useCommonWebRouter();
  const authenticatedWebRouter = useAuthenticatedWebRouter();

  return useMemo(
    () => [
      ...publicWebRouter,
      { children: [...authenticatedWebRouter, ...commonWebRouter], element: <FetchUserGuard /> },
    ],
    [publicWebRouter, commonWebRouter, authenticatedWebRouter],
  );
};
